exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".two-dimensional-image .canvas__img{visibility:hidden}.two-dimensional-image .canvas .konva-wrapper{background:transparent;position:absolute;top:0}\n", ""]);
